import PathToGolf from './path-to-golf'

export default PathToGolf
